module.exports = __webpack_public_path__ + "static/media/happy_ladies_desktop.98ad54ad.png";